import type { RolesColumnKey } from "@/modules/roles";
import type { FilterDefinition, ToastApi } from "@/ds";
import { createExportFeedback, describeReportFilters, useFileExport } from "@/modules/export";
import { exportRoles } from "@/modules/roles";
import type { RoleSort } from "@/modules/roles";
import { ROLES_EXPORT_FILE_NAME, ROLES_PERMISSION_FILTER_KEY } from "../roles.constants";

interface UseRolesExportacaoParams {
  /** Colunas visíveis da tela, na ordem; a exportação leva só elas. */
  readonly colunas: readonly RolesColumnKey[];
  readonly search: string;
  readonly claims: string[];
  readonly sort: RoleSort;
  readonly filterColumns: FilterDefinition[];
  /** Listagem vazia: Exportar Visualização avisa "nada a exportar" sem pedir o arquivo. */
  readonly isEmpty: boolean;
  readonly toast: ToastApi;
}

/**
 * Exportar Visualização (HU 1442): o arquivo é gerado pelo servidor com a busca, as permissões e a ordenação em vigor,
 * sem paginação, e o servidor registra a exportação na auditoria.
 */
export function useRolesExportacao({
  colunas,
  search,
  claims,
  sort,
  filterColumns,
  isEmpty,
  toast,
}: UseRolesExportacaoParams) {
  return useFileExport({
    fileName: ROLES_EXPORT_FILE_NAME,
    loadFile: (format) =>
      exportRoles({
        pesquisa: search,
        claims,
        sort,
        filtros: describeReportFilters(search, filterColumns, {
          [ROLES_PERMISSION_FILTER_KEY]: claims,
        }),
        colunas,
        format,
      }),
    isEmpty: () => isEmpty,
    ...createExportFeedback(toast),
  });
}
